/**
 * HR acting as someone, as this TAB remembers it: who, and the note.
 *
 * The API decides every request on its own (api/src/auth/actor.ts): it honours the header only
 * for HR, refuses a missing note, and logs and announces every write. This file only carries the
 * choice from one request to the next. sessionStorage, so it ends with the tab rather than
 * following the person into tomorrow, and it never survives into another tab by accident.
 */
const STORAGE_KEY = "scheduler.actingAs";

export const ACT_AS_HEADER = "x-act-as";
export const ACT_AS_NOTE_HEADER = "x-act-as-note";

export interface ActingAs {
  /** The EE Key of the person acted as. */
  ajeraKey: string;
  name: string;
  note: string;
}

export function actingAs(): ActingAs | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as Partial<ActingAs>;
    return value.ajeraKey && value.name && value.note ? { ajeraKey: value.ajeraKey, name: value.name, note: value.note } : null;
  } catch {
    return null;
  }
}

export function setActingAs(value: ActingAs | null): void {
  try {
    if (value) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage blocked: acting-as cannot be held, so nothing is sent and nobody is acted as.
  }
}

/** The headers for the current choice. The note is URL-encoded: headers carry Latin-1 only. */
export function actingHeaders(): Record<string, string> {
  const current = actingAs();
  return current ? { [ACT_AS_HEADER]: current.ajeraKey, [ACT_AS_NOTE_HEADER]: encodeURIComponent(current.note) } : {};
}
